var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full flex items-center gap-1.5 p-1.5 rounded-md bg-neutral-10 cursor-default"},[_c('SolidImageIcon'),_c('BaseText',{staticClass:"text-text-muted",attrs:{"type":"label","size":"xs"}},[_vm._v(" Beta ")]),_c('BaseText',{staticClass:"text-text-muted",attrs:{"type":"body","size":"xs"}},[_vm._v(" Image Ads Only ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }